import React from "react";

const TemarioDiplomaturaNutricionPlantBased = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Generalidades"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Definición de ABP"}</span></li>
                <li><span className="fw-light">{"Diferenciación de Veganismo, vegetarianismo, flexitarianismo y ABP"}</span></li>
                <li><span className="fw-light">{"Hábitos alimentarios en nuestro país y el mundo"}</span></li>
                <li><span className="fw-light">{"Tendencias"}</span></li>
                <li><span className="fw-light">{"Motivaciones: Ética, salud, medio ambiente"}</span></li>
                <li><span className="fw-light">{"Posicionamiento de organismos internacionales"}</span></li>
                <li><span className="fw-light">{"Organizaciones referentes nacionales e internacionales"}</span></li>
                <li><span className="fw-light">{"Sello Vegano"}</span></li>
                <li><span className="fw-light">{"Sustentabilidad"}</span></li>
                <li><span className="fw-light">{"Agroecología"}</span></li>
            </ul>
            <br /><br />
            <b>{"Grupos de alimentos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Legumbres"}</span></li>
                <li><span className="fw-light">{"Cereales"}</span></li>
                <li><span className="fw-light">{"Frutos secos"}</span></li>
                <li><span className="fw-light">{"Semillas"}</span></li>
                <li><span className="fw-light">{"Vegetales"}</span></li>
                <li><span className="fw-light">{"Frutas"}</span></li>
                <li><span className="fw-light">{"Derivados de soja"}</span></li>
                <li><span className="fw-light">{"Otros"}</span></li>
                <li><span className="fw-light">{"Activación"}</span></li>
                <li><span className="fw-light">{"Formas de preparación"}</span></li>
                <li><span className="fw-light">{"Contenido de nutrientes"}</span></li>
                <li><span className="fw-light">{"Práctica: Recetas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Nutrientes críticos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Proteínas: Complementación proteica"}</span></li>
                <li><span className="fw-light">{"Aminoácido limitante"}</span></li>
                <li><span className="fw-light">{"PDCAAS"}</span></li>
                <li><span className="fw-light">{"DIAAS"}</span></li>
                <li><span className="fw-light">{"Hierro"}</span></li>
                <li><span className="fw-light">{"Vitamina B12"}</span></li>
                <li><span className="fw-light">{"Calcio"}</span></li>
                <li><span className="fw-light">{"Zinc"}</span></li>
                <li><span className="fw-light">{"Yodo"}</span></li>
                <li><span className="fw-light">{"Omega"}</span></li>
                <li><span className="fw-light">{"Alimentos fuente"}</span></li>
                <li><span className="fw-light">{"Factores facilitadores e inhibidores"}</span></li>
                <li><span className="fw-light">{"Biodisponibilidad"}</span></li>
                <li><span className="fw-light">{"Signos de Carencia"}</span></li>
                <li><span className="fw-light">{"IDR"}</span></li>
                <li><span className="fw-light">{"Uso de suplementos"}</span></li>
            </ul>
            <br /><br />
            <b>{"Interacción con la microbiota"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Fibra"}</span></li>
                <li><span className="fw-light">{"Componentes de la fibra"}</span></li>
                <li><span className="fw-light">{"Tipos de fibra"}</span></li>
                <li><span className="fw-light">{"Alimentos fuente"}</span></li>
                <li><span className="fw-light">{"Microbiota: definición, funciones, factores determinantes"}</span></li>
                <li><span className="fw-light">{"Interacción entre la fibra y la MB"}</span></li>
                <li><span className="fw-light">{"MB eubiótica y disbiótica"}</span></li>
                <li><span className="fw-light">{"Efectos en la salud"}</span></li>
            </ul>
            <br /><br />
            <b>{"Enfermedades crónicas no transmisibles y ABP"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Enfermedades metabólicas"}</span></li>
                <li><span className="fw-light">{"Diabetes"}</span></li>
                <li><span className="fw-light">{"Enfermedades cardiovasculares"}</span></li>
                <li><span className="fw-light">{"Cáncer"}</span></li>
            </ul>
            <br /><br />
            <b>{"ABP a lo largo de la vida"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Embarazo"}</span></li>
                <li><span className="fw-light">{"Lactancia"}</span></li>
                <li><span className="fw-light">{"Primera infancia"}</span></li>
                <li><span className="fw-light">{"Alimentación complementaria"}</span></li>
                <li><span className="fw-light">{"Escolaridad"}</span></li>
                <li><span className="fw-light">{"Adolescencia"}</span></li>
                <li><span className="fw-light">{"Adultez"}</span></li>
                <li><span className="fw-light">{"Adulto mayor"}</span></li>
                <li><span className="fw-light">{"Características de la alimentación en cada etapa"}</span></li>
                <li><span className="fw-light">{"Adaptación de ABP"}</span></li>
                <li><span className="fw-light">{"Nutrientes críticos"}</span></li>
                <li><span className="fw-light">{"Uso de suplementos"}</span></li>
            </ul>
            <br /><br />
            <b>{"ABP en situaciones especiales"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Deporte: bases fisiológicas del ejercicio"}</span></li>
                <li><span className="fw-light">{"Características de la alimentación en deportes de fuerza y resistencia"}</span></li>
                <li><span className="fw-light">{"Adaptación de ABP para deportistas de elite"}</span></li>
                <li><span className="fw-light">{"Uso de suplementos"}</span></li>
                <li><span className="fw-light">{"Alimentación hospitalaria: Adaptación de ABP para pacientes hospitalizados"}</span></li>
                <li><span className="fw-light">{"Trastornos de la conducta alimentaria: Etiología, diagnóstico."}</span></li>
                <li><span className="fw-light">{"Intervención nutricional en pacientes con ABP"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaNutricionPlantBased;
